// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__V_KMd","name":"ConsentHeader_name__1WeQA","birthday":"ConsentHeader_birthday__1c7mC","skeleton":"ConsentHeader_skeleton__LvQlu"};